import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import BankForm from '../../components/forms/BankForm';
import { useAuth } from '../../contexts/AuthContext';
import { dataHelpers } from '../../lib/supabase';
import toast from 'react-hot-toast';

const BankRegisterPage = () => {
  const navigate = useNavigate();
  const { company } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (bankData) => {
    if (!company?.id) {
      toast.error('Erro: dados da empresa não encontrados');
      return;
    }

    try {
      setLoading(true);
      
      console.log('Creating bank with data:', bankData);
      
      await dataHelpers.createBank(company.id, bankData);
      
      toast.success('Banco cadastrado com sucesso!');
      navigate('/dashboard/banks', {
        state: { message: 'Banco cadastrado com sucesso!' }
      });
    } catch (error) {
      console.error('Error creating bank:', error);
      toast.error('Erro ao cadastrar banco. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/dashboard/banks');
  };

  return (
    
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center space-x-4">
          <button
            onClick={handleCancel}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-gray-600" />
          </button>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Cadastrar Banco</h1>
            <p className="text-gray-600">
              Adicione uma nova conta bancária ao sistema
            </p>
          </div>
        </div>

        {/* Form */}
        <BankForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          loading={loading}
        />
      </div>
    
  );
};

export default BankRegisterPage;
